<template>
  <b-modal v-model="showModal" centered hide-header hide-footer no-close-on-backdrop>
    <div class="d-flex justify-content-end" v-on:click="close">
      <img v-bind:src="Logo" alt="down" class="header__logo" />
    </div>
    <div class="container" v-if="selectedExchange">
      <div class="cs-2fa__description"></div>
      <div class="qr-code-info-payment mb-4">
        <span>
          <img src="@/assets/img/lock.svg" alt="info" class="info-icon" />
        </span>
        <small>
          <div class="help__error">
            {{
              $t(
                `unauth-payment.${selectedExchange.name}-donot-have-fund-password`
              )
            }}
          </div>
          <div class="text-center">
            {{ $t(`unauth-payment.${selectedExchange.name}-fund-password`) }}
            <a
              class="help__link"
              href="https://www.okcoin.com/account/security"
              target="_blank"
            >
              {{
                $t(`unauth-payment.${selectedExchange.name}-security-link`)
              }}</a
            >
          </div>
        </small>
      </div>
      <Form @submit="handlePay">
        <div class="cs-auth-popup__inputs-box">
          <label>{{
            $t(`unauth-payment.${selectedExchange.name}-password-label`)
          }}</label>
          <text-input
            name="password"
            id="apiKey"
            v-model:value.trim="password"
            :type="
              excptionExchanges.includes(selectedExchange.name)
                ? 'text'
                : 'password'
            "
            :placeholder="
              $t(`unauth-payment.${selectedExchange.name}-password-label`)
            "
            ref="apiKey"
            :disabledCopy="true"
            :disabledRightClick="true"
          />
         
          <label
            class="checkboxcontainer"
            v-if="!excptionExchanges.includes(selectedExchange.name)"
          >
            {{ $t(`payment.${selectedExchange.name}-keep-safe-pass`) }}
            <input
              type="checkbox"
              v-on:click="checkboxClick(!savepassword)"
              :checked="savepassword"
            />
            <span class="checkboxcontainer__checkmark"></span>
          </label>
        </div>
        <!-- <powered-by margin-top /> -->
        <div class="error-field">{{ errors }}</div>
        <CustomButton
          className="cs-sign-in__btn button-default mt-4 w-100"
          type="submit"
          :name="$t('exchange-payment.pay')"
          :disabled="loaderButton"
          :loader="loaderButton"
        >
        </CustomButton>
      </Form>
    </div>
  </b-modal>
</template>

<script>
import { Form } from "vee-validate";
import CustomButton from "@/views/customButton.vue";
import cross from "../assets/img/cross.svg";

export default {
  name: "PaymentModal",
  components: {
    CustomButton,
    Form,
  },
  data() {
    return {
      showModal: false,
      password: "",
      Logo: cross,
      savepassword: true,
      checked: true,
      excptionExchanges: ["kraken", "coinbase"],
    };
  },
  props: {
    errors: String,
    loaderButton: Boolean,
    selectedExchange: Object,
    selectedExchangeCurrency: Object,
    passwordData: Object,
    error2fa: String,
    code2fa: String,
    show2faPopup: Boolean,
  },
  watch: {
    showModal() {
      this.clear();
    },
  },
  methods: {
    open() {
      this.showModal = true;
    },
    close() {
      this.showModal = false;
    },
    clear() {
      this.password = "";
    },
    handlePay() {
      this.savepassword = !this.excptionExchanges.includes(
        this.selectedExchange.name
      );
      this.$emit("exchangePayment", {
        password: this.password,
        savepassword: this.savepassword,
      });
    },
    checkboxClick(value) {
      this.savepassword = value;
    },
  },
};
</script>

<style lang="scss">
.error-field {
  color: #f53d3d;
  font-size: 12px;
  padding-top: 5px;
  width: 80%;
  margin: auto;
}
.orange-fill {
  width: 100% !important;
}
.checkboxcontainer {
  margin-top: 10px;
  font-size: 15px;
  color: #111;
  display: block;
  position: relative;
  padding-left: 35px;
  margin-bottom: 12px;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }
  input:checked ~ &__checkmark {
    background-color: #1b1f3b;
  }
  &__checkmark {
    position: absolute;
    top: 0;
    left: 0;
    height: 20px;
    width: 20px;
    border: 1px solid #333;
    border-radius: 5px;
    background-color: #fff;
    &::after {
      content: "";
      position: absolute;
      display: none;
      left: 7px;
      top: 3px;
      width: 5px;
      height: 10px;
      border: solid white;
      border-width: 0 3px 3px 0;
      -webkit-transform: rotate(45deg);
      -ms-transform: rotate(45deg);
      transform: rotate(45deg);
    }
  }
  input:checked ~ &__checkmark::after {
    display: block;
  }
}

.expand-panel {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 700;
  width: 100%;
  background: #fff;
  overflow: hidden;
  transition: 0.5s;
  box-shadow: 0 0 5px #333;
  height: 0 !important;
}
.container {
  padding: 10px 20px;
}
.full-height {
  height: 80% !important;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1039;
  width: 100%;
  background: #fff;
  overflow: hidden;
  transition: 0.5s;
  box-shadow: 0 0 5px #333;
  padding: 10px 5px;
  cursor: pointer;
}
.header {
  &__logo {
    width: 15px;
    cursor: pointer;
  }
}
.help {
  &__error {
    color: #333;
    font-weight: 800;
    text-align: center;
  }
  &__link {
    font-weight: 600;
    color: #4989f4;
  }
  &__link:hover {
    text-decoration: none;
  }
}
.qr-code-info-payment {
  display: flex;
  flex-flow: column;
  border: 1px solid #d7d8d6;
  padding: 12px 8px;
  border-radius: 4px;
  align-items: center;
  line-height: 15px;
  span {
    margin-right: 10px;
    width: 50px;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    background: #fff;
    img {
      width: 25px;
    }
  }
}
.cs-auth-popup {
  &__inputs-box {
    width: 80%;
    margin: auto;
  }
}
.info-icon {
  width: 20px;
}
.go-back {
  color: #000000;
  font-size: 16px;
  font-weight: 500;
  span {
    justify-content: center;
    img {
      width: 10px;
      margin-right: 10px;
    }
  }
  &:hover {
    color: #222641;
    text-decoration: none;
  }
}
.btn-wrapper {
  text-align: center;
}
</style>
